<p-dialog [(visible)]="visible" [modal]="true" [style]="{width: '80vw', maxWidth: '900px'}" [draggable]="false"
    [resizable]="false" styleClass="sequence-modal" (onHide)="onClose()">

    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <i class="pi pi-chart-line text-primary"></i>
            <span class="font-semibold text-xl">Sequence Details</span>
        </div>
    </ng-template>

    <div class="sequence-content" *ngIf="sequence">
        <!-- Basic Information -->
        <div class="grid mb-4">
            <div class="col-12">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-3 pb-0">
                            <h3 class="m-0 text-primary">{{ sequence.name }}</h3>
                            <p class="text-600 mt-1 mb-0">{{ sequence.description }}</p>
                        </div>
                    </ng-template>

                    <div class="grid">
                        <div class="col-12 md:col-6">
                            <div class="flex flex-column gap-3">
                                
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-list text-500"></i>
                                    <span class="font-medium">Steps:</span>
                                    <p-badge [value]="(sequence.numSteps||0).toString() " severity="info"></p-badge>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="flex flex-column gap-3">
                                
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-circle-fill text-500" [class]="getStatusIcon(sequence.status)"></i>
                                    <span class="font-medium">Status:</span>
                                    <p-badge [value]="sequence.status" [severity]="getStatusSeverity(sequence.status)">
                                    </p-badge>
                                </div>
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-calendar text-500"></i>
                                    <span class="font-medium">Created:</span>
                                    <span>{{ sequence.createdAt | date:'medium' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>

        <!-- Progress and Rates -->
        <div class="grid mb-4">
            <div class="col-12 md:col-4">
                <!-- <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-3 pb-2">
                            <h4 class="m-0">Progress</h4>
                        </div>
                    </ng-template>
                    <div class="text-center">
                        <p-progressBar [value]="sequence.progress" [showValue]="true" styleClass="mb-3">
                        </p-progressBar>
                    </div>
                </p-card> -->
            </div>
            <div class="col-12 md:col-4">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-3 pb-2">
                            <h4 class="m-0">Open Rate</h4>
                        </div>
                    </ng-template>
                    <div class="text-center">
                        <div class="text-3xl font-bold text-primary">
                            {{ getOpenRate(sequence.metrics) | number:'1.1-1' }}%
                        </div>
                    </div>
                </p-card>
            </div>
            <div class="col-12 md:col-4">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-3 pb-2">
                            <h4 class="m-0">Reply Rate</h4>
                        </div>
                    </ng-template>
                    <div class="text-center">
                        <div class="text-3xl font-bold text-green-500">
                            {{ getReplyRate(sequence.metrics) | number:'1.1-1' }}%
                        </div>
                    </div>
                </p-card>
            </div>
        </div>

        <!-- Metrics Section -->
        <div class="grid" *ngIf="sequence.metrics">
            <div class="col-12">
                <p-card>
                    <ng-template pTemplate="header">
                        <div class="p-3 pb-0">
                            <h3 class="m-0 flex align-items-center gap-2">
                                <i class="pi pi-chart-bar text-primary"></i>
                                {{ sequence.sequenceMedium === 'linkedin' ? 'LinkedIn' : 'Email' }} Metrics
                            </h3>
                        </div>
                    </ng-template>

                    <!-- LinkedIn Metrics -->
                    <div *ngIf="sequence.sequenceMedium === 'linkedin'" class="grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3" *ngFor="let metric of getLinkedInMetrics()">
                            <div class="surface-card border-round p-3 border-1 surface-border">
                                <div class="flex align-items-center justify-content-between">
                                    <div>
                                        <div class="text-500 font-medium mb-1">{{ metric.label }}</div>
                                        <div class="text-900 font-bold text-xl">{{ metric.value | number }}</div>
                                    </div>
                                    <div
                                        class="border-circle w-3rem h-3rem bg-blue-100 flex align-items-center justify-content-center">
                                        <i [class]="metric.icon" class="text-blue-500 text-xl"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Email Metrics -->
                    <div *ngIf="sequence.sequenceMedium === 'email'" class="grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3" *ngFor="let metric of getEmailMetrics()">
                            <div class="surface-card border-round p-3 border-1 surface-border">
                                <div class="flex align-items-center justify-content-between">
                                    <div>
                                        <div class="text-500 font-medium mb-1">{{ metric.label }}</div>
                                        <div class="text-900 font-bold text-xl">
                                            {{ metric.isPercentage ? ((metric.value || 0) | number:'1.1-2') + '%' :
                                            ((metric.value || 0) | number) }}
                                        </div>
                                    </div>
                                    <div
                                        class="border-circle w-3rem h-3rem bg-green-100 flex align-items-center justify-content-center">
                                        <i [class]="metric.icon" class="text-green-500 text-xl"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button label="Close" icon="pi pi-times" (onClick)="onClose()" severity="secondary">
            </p-button>
        </div>
    </ng-template>
</p-dialog>